import { Layout } from "layouts";
// Components
import { Hero, GetAQuote } from "@/components/pricing";

const Pricing: React.FC = () => {
    return (
        <Layout page="pricing">
            <Hero />
            <GetAQuote />
        </Layout>
    );
};

export default Pricing;
